import last from 'lodash/last';
import type { ConnectedProject } from '../../types';

export const getLastConnectedProject = (
	connectedProjects: ConnectedProject[] | undefined,
	projectIdToDisconnect: string,
) => {
	if (connectedProjects) {
		const connectedProjectsWithoutDisconnectedProject = connectedProjects.filter(
			(project) => project.id !== projectIdToDisconnect,
		);
		const lastConnectedProject = last(connectedProjectsWithoutDisconnectedProject);
		if (lastConnectedProject) {
			return {
				id: lastConnectedProject.id,
				resourceId: lastConnectedProject.resourceId,
				name: lastConnectedProject.name,
				avatarUrl: lastConnectedProject.avatarUrl,
			};
		}
	}
};
